<template>
<div class='model-details'>
    <common-back-header :backPath="backPath" :tabIndex="tabIndex" :currentIndex="currentIndex" :swiperIndex="swiperIndex"/>
    <div id="container1"  ref="ray"
      :style="{
                'background-image':'url(' + $util.aliOsUrl(playData.bgSrc) + ')',
                'background-size': '100% 100%',
                'background-repeat': 'no-repeat'
              }">
    </div>
    <div class="model-synopsis">
       <h3 class="p_title">{{ playData.name }}</h3>
       <div class="description" v-html="playData.description"></div>
       <div class="p_contain" v-if="relaticeList.length>0">
          <div class="p_icon"></div>
          <p class="p_relevant">相关推荐</p>
       </div>
       <div class="relative-content">
        <ul class="recommend">
            <li v-for='(item,index) of relaticeList' :key='index' @click='changeModel(item)'>
              <div class="img-box">
                <img :src="$util.aliOsUrl(item.coverImage)" alt="">
              </div>
              <div class="relaname">{{item.name}}</div>
            </li>
        </ul>
       </div>
    </div>
</div>
</template>

<script>
import CommonBackHeader from '@/views/layout/common-back-header'
import { course } from '@/agent'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
export default {
  name: 'ModelCourse',
  components: {
    'common-back-header': CommonBackHeader
  },
  props: {
  },
  data () {
    return {
      playData: {},
      relaticeList: [],
      backPath: '', // 返回路径
      tabIndex: '', // 上一页的tab页签
      /** 模型路径 */
      modeImg: '', // 颜色纹理
      normal: '', // 法线贴图
      Smoothness: '', // 金属度
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      controls: '',
      mixers: [],
      clock: new THREE.Clock(),
      modelType: 0,
      currentIndex: '',
      swiperIndex: ''
    }
  },
  created () {},
  mounted () {
    this.currentIndex = this.$route.query.currentIndex
    this.swiperIndex = this.$route.query.swiperIndex
    this.tabIndex = this.$route.query.tabIndex
    this.backPath = this.$route.query.backPath
    this.getModelDetails()
    this.getModelRelaticeList()
  },
  methods: {
    getModelRelaticeList () {
      let param = {
        pageNum: 1,
        pageSize: 10,
        query: {
          id: this.$route.query.modelId,
          isFine: 1
        },
        sorts: [
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ISNULL'
          },
          {
            sortPropertyName: 'orderNbr',
            sortType: 'ASC'
          }
        ]
      }
      course.getModelRelaticeList(param).then((res) => {
        if (res.code == 100) {
          console.log(res)
          this.relaticeList = res.data.list
        }
      })
    },
    getModelDetails () {
      course.getModelDetails(this.$route.query.modelId).then((res) => {
        if (res.code == 100) {
          this.playData = res.data
          let description = ''
          let descriptionArr = []
          console.log(JSON.parse(localStorage.getItem('playerCyData')))
          if (this.playData.description) {
            description = this.playData.description
            if (description.indexOf('\n') != -1) {
              descriptionArr = description.split('\n')
              for (let i = 0; i < descriptionArr.length; i++) {
                descriptionArr[i] = '<p>' + descriptionArr[i] + '</p>'
              }
              if (descriptionArr.length) {
                description = descriptionArr.join('')
              }
            } else {
              if (description.indexOf('<p>') == -1) {
                description = '<p>' + description + '</p>'
              }
            }
          } else {
            description = '<p>未知</p>'
          }
          this.playData.description = description
          // 模型
          this.modelType = this.playData.modelType
          const obj = {
            id: this.playData.id,
            attachs: this.playData.attachs,
            url: this.playData.modelFormat === 1 ? this.$util.aliOsUrlModel(this.playData.attachs[0].src) : this.$util.aliOsUrlModel(this.playData.src),
            albedo: this.$util.aliOsUrlModel(this.playData.albedo),
            normal: this.$util.aliOsUrlModel(this.playData.normal),
            metallic: this.$util.aliOsUrlModel(this.playData.metallic),
            rightBgSrc: this.$util.aliOsUrl(this.playData.rightBgSrc),
            leftBgSrc: this.$util.aliOsUrl(this.playData.leftBgSrc),
            upBgSrc: this.$util.aliOsUrl(this.playData.upBgSrc),
            downBgSrc: this.$util.aliOsUrl(this.playData.downBgSrc),
            backBgSrc: this.$util.aliOsUrl(this.playData.backBgSrc),
            frontBgSrc: this.$util.aliOsUrl(this.playData.frontBgSrc),
            type: this.playData.type,
            modelFormat: this.playData.modelFormat, // 模型格式
            scaling: this.playData.scaling,
            modelType: this.playData.modelType // 是动态模型还是静态模型
          }
          const that = this
          setTimeout(function () {
            that.initScene(obj)
            that.initCamera(obj, 'container1') // 相机
            that.init('container1', that.playData.type)
            that.render()
          }, 10)
        }
      })
    },
    init (nodename, type) {
      this.initWebGLRenderer(nodename, type)// 渲染器
      this.initAxisHelper()// 辅助坐标
      this.createControls(nodename)// 控件对象
      this.render()
    },
    // 创建场景对象Scene
    initScene (obj) { // 颜色纹理 ,法线贴图 ,金属度
      const that = this
      that.scene = new THREE.Scene()
      // 默认您已经创建了相机和渲染器，就直接在场景上加入背景就行
      if (obj.type === 2) {
        that.scene.background = new THREE.CubeTextureLoader().load([obj.rightBgSrc, obj.leftBgSrc, obj.upBgSrc, obj.downBgSrc, obj.backBgSrc, obj.frontBgSrc])// 添加天空盒子背景图
      }

      // 环境光
      const ambient = new THREE.AmbientLight(0xffffff)
      ambient.color = new THREE.Color('#cccccc')
      that.scene.add(ambient)

      // 点光源
      const point = new THREE.PointLight(0xffffff)
      point.position.set(400, 200, 300) // 点光源位置
      // 通过add方法插入场景中，不插入的话，渲染的时候不会获取光源的信息进行光照计算
      that.scene.add(point) // 点光源添加到场景中

      // 点光源2  位置和point关于原点对称
      const point2 = new THREE.PointLight(0xffffff)
      point2.position.set(-400, -200, -300) // 点光源位置
      that.scene.add(point2) // 点光源添加到场景中

      // 定向光
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
      that.scene.add(directionalLight)

      if (obj.modelFormat === 1) {
        // 加载GLTF模型
        const gltfLoder = new GLTFLoader()
        gltfLoder.load(obj.url, function (gltf) {
          gltf.scene.scale.set(1 * 50, 1 * 50, 1 * 50)
          gltf.scene.traverse(function (child) {
            if (child.isMesh) {
              child.material.emissive = child.material.color
              child.material.emissiveMap = child.material.map
            }
          })
          if (obj.modelType === 2) {
            that.mixers = new THREE.AnimationMixer(gltf.scene)
            const action = that.mixers.clipAction(gltf.animations[0])
            action.play()
          }
          that.scene.add(gltf.scene)
        }, function (e) {
          console.log(e)
        })
      } else {
      // 纹理贴图 创建一个纹理加载器
        const TextureLoader = new THREE.TextureLoader()
        // 加载FBX模型
        const texturePlante = new THREE.TextureLoader().load(obj.albedo)
        const fbxLoader = new FBXLoader()
        fbxLoader.load(obj.url, function (object) { // fbx模型
          object.traverse(function (child) {
            const material = new THREE.MeshPhongMaterial({
              map: texturePlante
            })
            child.material = material

            // // 加载法线贴图，表面细节更丰富
            const textureNormal = TextureLoader.load(obj.normal)
            child.material.normalMap = textureNormal

            // 设置高光贴图，一个网格模型不同的区域反射光线的能力不同
            const textureSpecular = TextureLoader.load(obj.metallic)
            child.material.specularMap = textureSpecular
            child.material.specular.set(0xffffff) // 高光反射颜色
            child.material.shininess = 15 // 高光高亮程度，默认30
            //  that.mesh = object
            if (child.isMesh) {
              child.castShadow = true
              child.receiveShadow = true
            }
            that.scene.add(object)
          })
        })
      }
    },
    // 相机
    initCamera (obj, nodename) {
      const container = document.getElementById(nodename)
      this.camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 1, 1000)
      console.log(obj.scaling)
      switch (obj.scaling) {
        case 0:
          this.camera.position.set(65, 65, 65)
          break
        case 10:
          this.camera.position.set(70, 70, 70)
          break
        case 20:
          this.camera.position.set(55, 55, 55)
          break
        case 30:
          this.camera.position.set(50, 50, 50)
          break
        case 40:
          this.camera.position.set(45, 45, 45)
          break
        case 50:
          this.camera.position.set(40, 40, 40)
          break
        case 60:
          this.camera.position.set(35, 35, 35)
          break
        case 70:
          this.camera.position.set(30, 30, 30)
          break
        case 80:
          this.camera.position.set(25, 25, 25)
          break
        case 90:
          this.camera.position.set(20, 20, 20)
          break
        case 100:
          this.camera.position.set(15, 15, 15)
          break
      }
      this.camera.lookAt(this.scene.position) // 设置相机方向(指向的场景对象)
    },
    // 网格
    initGrid () {
      const gridHelper = new THREE.GridHelper(2, 50, 0xff00ff, 0x808080)
      this.scene.add(gridHelper)
    },
    // 创建渲染器对象
    initWebGLRenderer (nodename, type) {
      // type 1是背景 2 是天空盒
      if (type === 1) {
        // 设置背景图
        const container = document.getElementById(nodename)
        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
        this.renderer.setClearAlpha(0.2)
        this.renderer.setSize(container.clientWidth, container.clientHeight) // 设置渲染区域尺寸

        // this.renderer.setClearColor(0xb9d3ff, 1); //设置背景颜色
        container.appendChild(this.renderer.domElement)// body元素中插入canvas对象
      } else {
        // 不设置背景图
        const container = document.getElementById(nodename)
        this.renderer = new THREE.WebGLRenderer({ antialias: true })
        this.renderer.setSize(container.clientWidth, container.clientHeight) // 设置渲染区域尺寸
        container.appendChild(this.renderer.domElement)// body元素中插入canvas对象
      }
    },
    // 辅助三维坐标系AxisHelper
    initAxisHelper () {
      this.axisHelper = new THREE.AxisHelper(250)
    },
    render () {
      const that = this
      requestAnimationFrame(this.render) // 请求再次执行渲染函数render
      if (that.modelType === 2) {
        const delta = that.clock.getDelta()
        if (that.mixers) that.mixers.update(delta)
        that.controls.update()
      }
      this.renderer.render(this.scene, this.camera)// 执行渲染操作
    },
    // 创建控件对象
    createControls (nodename) {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      const ctx = document.getElementById(nodename)
      const child = ctx.firstChild
      let a = 0
      child.addEventListener('wheel', (e) => {
        this.controls.enableZoom = true
        if (e.wheelDelta > 0) {
          if (a <= 5) {
            a = a + 1
          }
        } else if (e.wheelDelta < 0) {
          if (a >= -10) {
            a = a - 1
          }
        }
        if (a > 5 || a < -10) {
          this.controls.enableZoom = false
        }
      })
    },
    changeModel (item) {
      document.getElementById('container1').innerHTML = ''
      const that = this
      that.playData = item
      that.modelType = that.playData.modelType
      // 模型
      const obj = {
        id: this.playData.id,
        token: JSON.parse(localStorage.getItem('US_INFO'))
          ? JSON.parse(localStorage.getItem('US_INFO')).token
          : '',
        attachs: this.playData.attachs,
        url: this.playData.modelFormat === 1 ? this.$util.aliOsUrlModel(this.playData.attachs[0].src) : this.$util.aliOsUrlModel(this.playData.src),
        albedo: this.$util.aliOsUrlModel(this.playData.albedo),
        normal: this.$util.aliOsUrlModel(this.playData.normal),
        metallic: this.$util.aliOsUrlModel(this.playData.metallic),
        rightBgSrc: this.$util.aliOsUrl(this.playData.rightBgSrc),
        leftBgSrc: this.$util.aliOsUrl(this.playData.leftBgSrc),
        upBgSrc: this.$util.aliOsUrl(this.playData.upBgSrc),
        downBgSrc: this.$util.aliOsUrl(this.playData.downBgSrc),
        backBgSrc: this.$util.aliOsUrl(this.playData.backBgSrc),
        frontBgSrc: this.$util.aliOsUrl(this.playData.frontBgSrc),
        type: this.playData.type,
        modelFormat: this.playData.modelFormat, // 模型格式
        scaling: this.playData.scaling,
        modelType: this.playData.modelType // 是动态模型还是静态模型
      }
      setTimeout(function () {
        that.initScene(obj)
        that.initCamera(obj, 'container1') // 相机
        that.init('container1', that.playData.type)
        that.render()
      }, 10)
      that.getModelRelaticeList()// 获得相关推荐
      document.querySelector('#pageContainer').scrollTop = 0
    }
  }
}
</script>
<style lang='scss' scoped>
.model-details{
  min-height: 100%;
  background: #1d1e1f;
  overflow-y:auto;
  #container1{
    width: 100%;
    height: 260px;
  }
  .model-synopsis{
    padding: 20px 0;
    .p_title{
      color:#FFFFFF;
      font-size: 24px;
      margin-left: 20px;
    }
    .description{
      padding: 0 20px;
      margin-top: 23px;
      opacity: 1;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN-Normal;
      font-weight: Normal;
      text-align: left;
      color: #828282;
      line-height: 18px;

    }
    .description>p{
      text-indent: 25px;
      margin-bottom: 20px;
    }
    .p_contain{
      display: flex;
      margin-left: 20px;
      padding-top: 10px;
      .p_icon{
      width: 2px;
      height: 17px;
      opacity: 1;
      background: #e50914;
      border-radius: 1px;
      }
      .p_relevant{
        color: #F2F2F2;
        font-size: 15px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        line-height: 15px;
        margin-left: 8px;
      }
    }
    .relative-content{
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 20px;
      ul{
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li{
          width: 164px;
          height: 150px;
          opacity: 1;
          background: #252525;
          border-radius: 2px;
          margin-bottom: 7px;
          padding: 20px;
          box-sizing: border-box;
          img{
            max-width: 70px;
            margin: 0 auto;
            display: block;
            height: 70px;
          }
          .relaname{
            height: 15px;
            opacity: 1;
            font-size: 15px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: center;
            color: #828282;
            line-height: 15px;
            letter-spacing: 0px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin: 20px 0;
          }
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.model-details{
  .model-synopsis{
    .description>p{
      text-indent: 25px;
      margin-bottom: 20px;
    }
  }
}
</style>
